<template>
  <div class="app-keyword-group">
    <h5 class="app-keyword-group__title">{{ title }}</h5>
    <ul class="app-keyword-group__list">
      <li class="app-keyword-group__list-item" v-for="item in keywords" :key="item.id">{{ item.keyword }} ({{ item.size }})</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AppKeywordGroup',
  props: {
    title: {
      type: String,
      default: ''
    },
    keywords: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.app-keyword-group {
  padding-bottom: 30px;

  &:last-child {
    padding-bottom: 0;
  }

  &__title {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__list-item {
    display: inline-block;
    margin: 5px 15px 5px 0;
    color: $primary-color;
  }
}
</style>
